import React, { FC } from 'react'

import { TopicItemList } from '../../../models/topics/itemList'
import SpeakerList from './speakerList'

type Props = {
  data: TopicItemList
}

export const TopicItemLists: FC<Props> = ({ data }) => {
  const topicItemListData = {
    title: data?.title || '',
    useCase: data?.useCase || '',
    items: data?.items || [],
  }

  // Event Page Speaker List Component
  const speakerListData = topicItemListData.items.filter(
    (item: any) => item.__typename === 'ContentfulComponentBio'
  )

  return (
    <>
      {topicItemListData.useCase === 'Events' && speakerListData.length !== 0 && (
        <SpeakerList
          data={speakerListData}
          topicItemListUseCase={topicItemListData.useCase}></SpeakerList>
      )}
    </>
  )
}
